<div class="text-center">
  <img src="assets/img/isp_graphics/design-01ja85hrjx-1728998832.svg" class="img-fluid" alt="iSupplier no preview" style="width: 30rem;"/>
  <h4 class="mb-4" *ngIf="message">{{message}}</h4>
</div>
